<template>
  <div class="evaluate-item">
    <div class="order-number" v-if="item.number">订单编号：{{item.number}}</div>
    <div class="header">
      <!-- <img :src="item.head_img" alt="" srcset="" class="block-32"> -->
      <Avatar :src.sync="item.head_img" icon="ios-person" size="50"/>
      <div class="info">
        <div class="left">
          <div class="name">{{item.user_name}}</div>
          <div class="comment"><span>订单评价</span>
            <Rate disabled :value="item.order_star"/>
          </div>
        </div>
        <div class="right">
          <div class="time text-999">{{item.created_at}}</div>
          <div class="comment"><span>师傅评价</span>
            <Rate disabled :value="item.worker_star"/>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-content">{{item.evaluate}}</div>
    <div class="img-list">
      <el-image style="width: 80px; height: 80px" class="margin-right-10" :src="itm" :preview-src-list="item.img" :fit="'cover'" alt
        v-for="(itm,indx) in item.img" :key="indx">
      </el-image>
    </div>
    <div class="order" @click="$router.push({name:'order_detail',params:{id:item.order_id}})">
      <div class="left">
        <div class="project">{{item.title}}</div>
        <div class="address">地址：{{item.address}}</div>
      </div>
      <Icon class="icon" type="ios-arrow-forward" color="#666"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'evaluate-item',
  props: {
    item: {
      type: [ Array, Object],
      default: {}
    }

  },
  data () {
    return {

    }
  },
  methods () {

  }
}
</script>

<style scoped lang="less">
.evaluate-item {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 20px;

  .order-number {
    color: #333333;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .order {
    padding: 10px;
    background-color: #f7f8fa;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .project {
      color: #333333;
    }

    .address {
      color: #555555;
    }
  }

  .header {
    display: flex;

    .info {
      display: flex;
      flex: 1;
      height: 50px;
      padding-left: 10px;
      justify-content: space-between;

      .left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-weight: 600;
        }

        .comment {
          display: flex;
          align-items: center;
          color: #666666;

          span {
            margin-right: 3px;
          }
        }
      }

      .right {
        .time {
          text-align: right;
          margin-right: 10px;
        }

        .comment {
          display: flex;
          align-items: center;
          color: #666666;

          span {
            margin-right: 3px;
          }
        }
      }
    }
  }

  .comment-content {
    margin-top: 10px;
    color: #333333;
  }

  .img-list {
    display: flex;
    margin-top: 10px;

    .img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 3px;
      margin-right: 10px;
    }
  }
}
</style>
